import Immutable from 'immutable';
import { PunchStatusValue } from 'records/Punch';
import { RFIImpactCategoryKind } from './ImpactCategory';
import { NewMarkup, RawNewMarkup } from './NewMarkup';
import { RawUploadData, UploadData } from './UploadData';

export interface RawNewPunch {
  projectid: string;
  description: string;
  clientcreateddate: number;
  location: string;
  assignees: string[];
  groupAssignees: string[];
  duedate: number;
  disciplines: string[];
  comment: string;
  priority: string;
  photos: RawUploadData[];
  insertedphotos: string[];
  markups: RawNewMarkup[];
  statusValue: PunchStatusValue;
  status: string;
  distributionlist: string[];
  impactcategory: RFIImpactCategoryKind;
}

export interface NewPunchData {
  projectid: string;
  description: string;
  clientcreateddate: number;
  location: string;
  status: string;
  assignees: Immutable.OrderedSet<string>;
  groupAssignees: Immutable.OrderedSet<string>;
  duedate: number;
  disciplines: Immutable.OrderedSet<string>;
  comment: string;
  priority: string;
  photos: Immutable.List<UploadData>;
  insertedphotos: Immutable.List<string>;
  markups: Immutable.List<NewMarkup>;
  statusValue: PunchStatusValue;
  distributionlist: Immutable.OrderedSet<string>;
  impactcategory: RFIImpactCategoryKind;
}

const defaultValues: NewPunchData = {
  projectid: '',
  description: '',
  clientcreateddate: 0,
  location: '',
  assignees: Immutable.OrderedSet<string>(),
  groupAssignees: Immutable.OrderedSet<string>(),
  duedate: 0,
  status: PunchStatusValue.OPEN,
  disciplines: Immutable.OrderedSet<string>(),
  comment: 'none',
  priority: 'Normal',
  photos: Immutable.List<UploadData>(), // Type this.
  insertedphotos: Immutable.List<string>(),
  markups: Immutable.List<NewMarkup>(), // Type this.
  statusValue: PunchStatusValue.OPEN,
  distributionlist: Immutable.OrderedSet<string>(),
  impactcategory: 'NONE',
};

export const NewPunchFactory = Immutable.Record(defaultValues, 'NewPunch');

export class NewPunch extends NewPunchFactory {
  static deserialize(rawNewPunch: RawNewPunch): NewPunch {
    return new NewPunch({
      ...rawNewPunch,
      disciplines: Immutable.OrderedSet(rawNewPunch.disciplines),
      assignees: Immutable.OrderedSet(rawNewPunch.assignees),
      groupAssignees: Immutable.OrderedSet(rawNewPunch.groupAssignees),
      photos: Immutable.List(rawNewPunch.photos.map(UploadData.deserialize)),
      insertedphotos: Immutable.List(rawNewPunch.insertedphotos),
      markups: Immutable.List(rawNewPunch.markups.map(NewMarkup.deserialize)),
      distributionlist: Immutable.OrderedSet(rawNewPunch.distributionlist),
    });
  }

  serialize(): RawNewPunch {
    return {
      ...this.toJS(),
      photos: this.photos.map((ud) => ud.serialize()).toArray(),
      markups: this.markups.map((m) => m.serialize()).toArray(),
    };
  }
}
